import {megaDispatch} from './megaDispatch'
import {setMessage, isVisible} from './message'
import {setLoadingStatus} from './loaderAction';


export const userIsLoading = bool => {
    return {
        type: 'USER_IS_LOADING',
        isLoading: bool
    }
}

export const userFetchDataSuccess = userData => {
    return {
        type: 'USER_FETCH_DATA_SUCCESS',
        userData
    };
}

export const userInactive = () => {
    return {
        type: 'USER_INACTIVE',
        whatToDo: 'Destroy!'
    };
}

export const checkLoggedIn = (url, userData) => {
     
        let data = new FormData;
        data.append('userData', JSON.stringify(userData) );

     return (dispatch) => {
   
        fetch(url + '/api/user/action/checkLoggedIn',
        {
            method: "POST",
            body: data
        })
        .then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
           
            return response;
        })
        .then((response) => response.json())
        .then((items) => {
           if(items.user_inactive_logout) {
                dispatch(userInactive())
           }

        })
        .catch(() => dispatch(setMessage({type: 'danger', message: 'Kan helaas niet inloggen'})));
    };
}

export const userFetchData = (url, postData) => {
    let data = new FormData();

    data.append('username', postData.username );
    data.append('password', postData.password );

    return (dispatch) => {

        dispatch(userIsLoading(true));
         dispatch(setLoadingStatus({reducer: 'UserReducer', status: true}))
        fetch(url,
        {
            method: "POST",
            body: data
        })
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                dispatch(userIsLoading(false));

                return response;
            })
            .then((response) => response.json())
            .then((items) => {
                
                
                dispatch(userFetchDataSuccess(items)) 
                dispatch(megaDispatch(postData.host))               
                dispatch(setLoadingStatus({reducer: 'UserReducer', status: false}))

                dispatch(setMessage(items.message))

            })
            .catch(() => dispatch(setMessage({type: 'danger', message: 'Kan helaas niet inloggen'})));
    };
}

export const updateUser = (url, userId, postData) => {

    let data = new FormData;

    data.append('userId', userId );
    data.append('postData', JSON.stringify(postData) );

    return (dispatch) => {
        dispatch(setLoadingStatus({reducer: 'UserReducer', status: true}))
        fetch(url,
        {
            method: "POST",
            body: data
        })
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }

                return response;
            })
            .then((response) => response.json())
            .then((items) => {
                items = JSON.parse(items);
                dispatch(setLoadingStatus({reducer: 'UserReducer', status: false}))
                if(!items.message) {
                    //dispatch(setMessage(items.message))
                }else{
                   dispatch(setMessage({type: items.type, message: items.message}))
                }

            })
            .catch((error) => {
                if(error) {

                    //dispatch(setMessage({type: 'danger', message: error}))
                }

            });
    };
}



// WEBPACK FOOTER //
// ./src/actions/user.js